import React, { useMemo } from "react"
import { graphql } from "@apollo/client/react/hoc"
import { compose } from "ramda"
import { getMember } from "../../queries/member"
import { useCoachToolsProfilePhoto } from "../../queries/profilePhoto"
import { mergeMemberDisplayPhoto } from "../../../utils/memberPhoto"
import { useMembershipJourney } from "../../../hooks/useMembershipJourney"
import ProfileWidget, { LoadingProfile } from "./Profile"
import CompactProfileWidget, { LoadingCompactProfile } from "./CompactProfile"
import ErrorLoadingProfile from "./ErrorLoadingProfile"
import WrapWithFetch from "../WrapWithFetch"
import { applyPendingAffiliateDisplayUser } from "./displayUser"

export { applyPendingAffiliateDisplayUser } from "./displayUser"

const useMemberWithDisplayPhoto = user => {
  const coachToolsProfilePhoto = useCoachToolsProfilePhoto()
  return useMemo(
    () => mergeMemberDisplayPhoto(user, coachToolsProfilePhoto),
    [user, coachToolsProfilePhoto],
  )
}

const ProfileBriefWithCoachToolsPhoto = props => {
  const user = useMemberWithDisplayPhoto(props.user)
  const { person } = useMembershipJourney()
  const displayUser = useMemo(
    () => applyPendingAffiliateDisplayUser(user, person),
    [user, person],
  )

  return <ProfileWidget {...props} user={displayUser} />
}

const CompactProfileBriefContent = ({ user, loading }) => {
  const { person } = useMembershipJourney()
  const displayUser = useMemo(
    () => applyPendingAffiliateDisplayUser(user, person),
    [user, person],
  )

  return (
    (loading && <LoadingCompactProfile />) || (
      <CompactProfileWidget user={displayUser} />
    )
  )
}

const attachQuery = compose(
  graphql(getMember, {
    props: ({ data }) => ({
      data,
      loading: data.loading,
      user: data.me,
      error: data.error,
      refetch: data.refetch,
    }),
  }),
)

export const CompactProfileBrief = attachQuery(CompactProfileBriefContent)

const ProfileBriefContent = WrapWithFetch(
  ({ user, loading, isFetching, error, refetch, reload, vertical }) => {
    if (loading || isFetching) {
      return <LoadingProfile vertical={vertical} />
    } else if (error || !user) {
      return <ErrorLoadingProfile {...{ refetch, reload }} />
    }

    return (
      <ProfileBriefWithCoachToolsPhoto
        user={user}
        error={error}
        refetch={refetch}
        vertical={vertical}
      />
    )
  },
)

export default attachQuery(ProfileBriefContent)
